var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#010101","d":"M37.802,46.247L12.376,24L37.801,1.753c0.416-0.364,0.458-0.996,0.094-1.411\n\tc-0.364-0.417-0.994-0.459-1.411-0.095l-26.286,23C9.982,23.438,9.857,23.712,9.857,24s0.125,0.562,0.342,0.753l26.286,23\n\tC36.675,47.919,36.91,48,37.143,48c0.278,0,0.555-0.115,0.753-0.342C38.26,47.243,38.218,46.611,37.802,46.247z"}));
}

ArrowLeft.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"48px","height":"48px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
